<template>
    <position-timeline-base :customer-view="true"/>
</template>

<script>
import PositionTimelineBase from '@/components/timeline/position-timeline-base';

export default {
    name: 'customer-timeline-list-page',
    components: {
        PositionTimelineBase,
    },
    metaInfo() {
        return {
            title: this.$t('Timeline'),
        };
    },
};
</script>
